import type { Data } from "@eai-toolkit/client";

import type { DataAccessLevel } from "../../../helpers/api";

export interface NewJobParams {
  sourceData: Data[] | null;
  jobName?: string;
  accountId: string;
  imageId: string;
  useLab: boolean;
  randomJobName: string;
  cpu: number;
  mem: number;
  gpu: number;
  gpuMem: number | null;
}

export interface JobConfig {
  sourceData: Data[];
  artifactDataId: string;
  dataFolderName: string;
  jobName: string;
  imageId: string;
  useLab: boolean;
  cpu: number;
  mem: number;
  gpu: number;
  gpuMem: number | null;
  dataAccessLevels?: DataAccessLevel[];
}

export enum RequestStatus {
  NONE = "NONE",
  FETCHING = "FETCHING",
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}
